import React from "react";
import "./pricingHero.css";
import { t } from "i18next";
// import PricingBackground from "../../assets/PricingBackground.jpg";

const PricingHero = () => {
  return (
    <section
      className="pricing-hero" /* style={{ backgroundImage: `url(${PricingBackground})` }} */
    >
      <div>
        <button className="pricing-button-hero">
          {t("pricing-hero.button")}
        </button>
      </div>
      <header className="p-headings">
        <h1>{t("pricing-hero.heading")}</h1>
        <h2 style={{ color: "rgba(181, 181, 181, 1)" }}>
          {t("pricing-hero.heading2")}
        </h2>
      </header>
      <article className="p-hero-body">
        <p className="p-hero-paragraph">
          {t("pricing-hero.text")}
          <br></br>
          {t("pricing-hero.text2")}
        </p>
      </article>
    </section>
  );
};

export default PricingHero;
